import { nextFrame } from './dom.js';

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }
  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
const scaleToFit = _async(function () {
  let {
    element,
    offset = 32,
    aspectRatio,
    maxScale
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let scale = 1;
  if (!element.parentElement) {
    return;
  }
  element.parentElement.style.overflow = 'hidden';
  if (['relative', 'absolute', 'fixed'].indexOf(window.getComputedStyle(element.parentElement, null).getPropertyValue('position')) === -1) {
    element.parentElement.style.position = 'relative';
  }
  element.style.position = 'absolute';
  element.style.transformOrigin = 'left top';
  return _call(nextFrame, function () {
    let elementWidth = element.offsetWidth;
    const elementHeight = element.offsetHeight;
    let containerWidth = element.parentElement.offsetWidth;
    let containerHeight = element.parentElement.offsetHeight;
    containerWidth -= offset;
    containerHeight -= offset;
    if (aspectRatio) {
      elementWidth = Math.max(elementWidth, Math.round(elementHeight * aspectRatio));
      element.style.width = `${elementWidth}px`;
    }
    const boundRatioX = containerWidth / elementWidth;
    const boundRatioY = containerHeight / elementHeight;
    scale = boundRatioX < boundRatioY ? boundRatioX : boundRatioY;
    if (maxScale) {
      scale = Math.min(scale, maxScale);
    }
    const targetWidth = Math.round(elementWidth * scale);
    const targetHeight = Math.round(elementHeight * scale);
    containerHeight += offset;
    containerWidth += offset;
    element.style.transform = `scale(${scale})`;
    element.style.left = `${Math.round((containerWidth - targetWidth) * 0.5)}px`;
    element.style.top = `${Math.round((containerHeight - targetHeight) * 0.5)}px`;
  });
});

export { scaleToFit };
//# sourceMappingURL=scale-to-fit.js.map
